import { NotificationUI } from './notifcationUI';
import Cookies from 'js-cookie';

export class Notification {
  private ui = new NotificationUI();

  public constructor(type: 'success'|'danger'|'info', title: string, text: string, private focus: boolean = false, duration?: number) {
    this.ui.render(type, title, text, focus, duration);
  }
}


class PermanentNotification {
  private id: string;

  public constructor(private $base: JQuery) {
    const self = this;
    this.id = this.$base.attr('id');

    this.$base.find('.notification__close').on('click', () => {
      this.destroy();
      this.writeCookie();
    });

    if (this.isClosed()) {
        this.destroy();
    } else {
      this.show();
    }
  }

  private writeCookie() : void {
    const id = this.id;
    const cookie = this.getNotificationCookie();
    cookie.push(id);
    Cookies.set('closedNotifications', JSON.stringify(cookie), {
      path: '/'
    });
  }

  private getNotificationCookie() : any {
    if (typeof Cookies.get('closedNotifications') !== 'undefined' && Cookies.get('closedNotifications') && Cookies.get('closedNotifications') !== '') {
      return JSON.parse(decodeURIComponent(Cookies.get('closedNotifications')));
    }
    return [];
  }

  private isClosed() : boolean {
    const filter = this.getNotificationCookie().filter((val) => val === this.id);
    return filter.length > 0;

  }

  private destroy() : void {
    this.$base.remove();
  }

  private show() : void {
    this.$base.show();
  }
}

// Quick & Dirty for handling/close permanent/serverside notifications
$('.notification--permanent').each((index, item) => {
  new PermanentNotification($(item));
});
